import { useEffect } from 'react';

// eslint-disable-next-line import/named
import { RouteComponentProps } from 'react-router';

import { urlUtils } from '../../utils';

type ItemRoute = RouteComponentProps<
  {
    vrid: number;
    type: 'collection' | 'delivery';
    concessionStoreId?: number;
    id: number;
    item: number;
    index: string;
  },
  {}
>;

type Props = ItemRoute;

export function RestaurantMenuOptions(props: Props): null {
  const { params } = props;

  useEffect(() => {
    const { vrid, type, id, concessionStoreId } = params;
    const hasConcessionStoreId = concessionStoreId
      ? `/${concessionStoreId}`
      : '';
    urlUtils.navigateToHash(
      `/restaurant/${vrid}/${type}/${id}${hasConcessionStoreId}`,
    );
  }, []);

  return null;
}
